<template>
  <div>
    <div>
      <template v-if="$route.query.request">
        <div class="notification notification-notice" style="padding:10px 15px 35px 15px;">
          <div class="notification-inner">
            <span class="notification-icon"></span>
            <span class="notification-text">{{$t('homeRequestSuccessfulMessage')}}</span>
            <a @click="hideSuccessMessage" class="notification-dismiss" data-notification-dismiss></a>
          </div>
        </div>
      </template>
    </div>
    <component v-bind:is="headerComponent"></component>
    <div>
      <ul class="row-container row-container--l category-boxes cf">

        <li @click="trackPageClick('using_sitename')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'using-site'}">
            <h3 class="title">{{categories[getCategoryIdByName('using-site')].title}}</h3>
            <svg
              class="icon"
              width="50px"
              height="50px"
              viewBox="0 0 60 60"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Payment & Billing</title>
              <path
                d="M9,34H27a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2H9Zm26-4a1,1,0,0,0,0-2H27a1,1,0,0,0,0,2h8ZM9,30H23a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2H9ZM59,18H5a1,1,0,0,0,0,2H58V39a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V17a1,1,0,0,0-2,0V39a5,5,0,0,0,5,5H55a5,5,0,0,0,5-5V19a1,1,0,0,0-1-1h0ZM60,5V15a1,1,0,0,1-2,0V5a3,3,0,0,0-3-3H5A3,3,0,0,0,2,5v5H55a1,1,0,0,1,0,2H1a1,1,0,0,1-1-1V5A5,5,0,0,1,5,0H55a5,5,0,0,1,5,5h0Z"
              ></path>
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('using-site')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('billing_support')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'billing-support'}">
            <h3 class="title">{{categories[getCategoryIdByName('billing-support')].title}}</h3>
            <svg
              class="icon"
              width="50px"
              height="50px"
              viewBox="0 0 40 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>House Icon</title>
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(2.000000, 0.000000)" fill="#000000">
                  <polygon points="18 0 0 9.20842361 0 13 18 13 36 13 36 9.20842361"></polygon>
                  <polygon points="26 29 32 29 32 16 26 16"></polygon>
                  <polygon points="15 29 21 29 21 16 15 16"></polygon>
                  <polygon points="4 29 10 29 10 16 4 16"></polygon>
                  <polygon points="0 39 36 39 36 33 0 33"></polygon>
                </g>
              </g>
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('billing-support')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('account_support')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'account-support'}">
            <h3 class="title">{{categories[getCategoryIdByName('account-support')].title}}</h3>
            <svg
              class="icon"
              width="50px"
              height="50px"
              viewBox="0 0 60 60"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>account</title>
              <path
                d="M60,30A30,30,0,0,1,30,60,30.33,30.33,0,0,1,5.7,47.62a1,1,0,0,1-.14-1A1,1,0,0,1,6.48,46H48a1,1,0,0,1,0,2H8.55A28,28,0,0,0,58,30,28,28,0,0,0,2,30,27.71,27.71,0,0,0,5,42.62a1,1,0,1,1-1.79.9A29.69,29.69,0,0,1,0,30a30,30,0,0,1,60,0M42.49,10.67a1,1,0,0,1-1.37.36A22,22,0,0,0,8,30a19.77,19.77,0,0,0,3.79,12.39,1,1,0,0,1-1.58,1.22A22,22,0,0,1,6,30,24,24,0,0,1,42.14,9.3a1,1,0,0,1,.36,1.37m10,6.33a1,1,0,0,1-.37,1.37l-3.46,2a1,1,0,1,1-1-1.73l3.46-2a1,1,0,0,1,1.37.37m2.6,6.27a1,1,0,0,1-.71,1.22l-3.86,1a1,1,0,0,1-.26,0,1,1,0,0,1-.26-2l3.86-1a1,1,0,0,1,1.22.71M51,29h4a1,1,0,0,1,0,2H51a1,1,0,0,1,0-2M30,32a2,2,0,1,1,2-2,2,2,0,0,1-2,2M46.29,12.29L32,26.57A4,4,0,0,0,30,26a4,4,0,0,0-4,4,4,4,0,0,0,.57,2l-3.27,3.27a1,1,0,1,0,1.41,1.41L28,33.43A4,4,0,0,0,30,34a4,4,0,0,0,4-4,4,4,0,0,0-.57-2L47.71,13.71a1,1,0,0,0-1.41-1.41"
              ></path>
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('account-support')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('technical_support')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'technical-support'}">
            <h3 class="title">{{categories[getCategoryIdByName('technical-support')].title}}</h3>
            <svg
              class="icon"
              width="50px"
              height="50px"
              viewBox="0 0 60 60"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Technical Support</title>
              <path
                d="M39,54H36V49a1,1,0,0,0-2,0v6a1,1,0,0,0,1,1h4a3.34,3.34,0,0,1,2.78,2H18.23A3.34,3.34,0,0,1,21,56H31a1,1,0,0,0,0-2H26V49a1,1,0,0,0-2,0v5H21a5.27,5.27,0,0,0-5,5,1,1,0,0,0,1,1H43a1,1,0,0,0,1-1,5.27,5.27,0,0,0-5-5M20,20.54l-2.83,2.83a1,1,0,1,0,1.41,1.41L21.46,22A1,1,0,0,0,20,20.54M14,17a1,1,0,0,0,1,1h4a1,1,0,1,0,0-2H15a1,1,0,0,0-1,1m7.46-4.95L18.64,9.22a1,1,0,0,0-1.41,1.41L20,13.47a1,1,0,1,0,1.41-1.41m8.48,1.41,2.83-2.83a1,1,0,0,0-1.41-1.41l-2.83,2.83a1,1,0,1,0,1.41,1.41M26,11V7a1,1,0,0,0-2,0v4a1,1,0,1,0,2,0M55,0H5A5.18,5.18,0,0,0,0,5V31a1,1,0,0,0,2,0V5.07A3.17,3.17,0,0,1,5,2H55a3,3,0,0,1,3,3V41a2.93,2.93,0,0,1-3,3H5a2.93,2.93,0,0,1-3-3V36H55a1,1,0,0,0,1-1.28A44.9,44.9,0,0,0,50.17,22.3a3.07,3.07,0,0,0-4.06-1.09,2.89,2.89,0,0,0-.81.71,3.64,3.64,0,0,0-5.95.88,3.64,3.64,0,0,0-5.16,1.37l-6-8.32c-1.89-2.58-3.83-1.86-4.58-1.42a3.2,3.2,0,0,0-1.59,2.21,3.89,3.89,0,0,0,.52,2.63l7.57,12.25a1,1,0,1,0,1.7-1.05L24.29,18.25A1.87,1.87,0,0,1,24,17a1.19,1.19,0,0,1,.62-0.84c0.28-.16.93-0.54,2,0.87l7.72,10.74A1,1,0,0,0,36,26.69a1.63,1.63,0,1,1,2.82-1.63l0.66,1.14h0a1,1,0,0,0,1.73-1h0A1.63,1.63,0,0,1,44,23.56l1,1.71h0a1,1,0,1,0,1.73-1h0a1,1,0,0,1-.08-0.73,1,1,0,0,1,.43-0.59,1,1,0,0,1,.73-0.06,1,1,0,0,1,.65.5A44.06,44.06,0,0,1,53.65,34H1a1,1,0,0,0-1,1v6a5,5,0,0,0,5,5H55a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5M30,38a2,2,0,1,1-2,2,2,2,0,0,1,2-2"
              ></path>
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('technical-support')].body"></p>
          </router-link>
        </li>
        <li @click="trackPageClick('partners_authors')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'partners-authors'}">
            <h3 class="title">{{categories[getCategoryIdByName('partners-authors')].title}}</h3>
            <svg
              class="icon"
              width="50px"
              height="50px"
              viewBox="0 0 60 60"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Technical Support</title>
              <path
                d="M39,54H36V49a1,1,0,0,0-2,0v6a1,1,0,0,0,1,1h4a3.34,3.34,0,0,1,2.78,2H18.23A3.34,3.34,0,0,1,21,56H31a1,1,0,0,0,0-2H26V49a1,1,0,0,0-2,0v5H21a5.27,5.27,0,0,0-5,5,1,1,0,0,0,1,1H43a1,1,0,0,0,1-1,5.27,5.27,0,0,0-5-5M20,20.54l-2.83,2.83a1,1,0,1,0,1.41,1.41L21.46,22A1,1,0,0,0,20,20.54M14,17a1,1,0,0,0,1,1h4a1,1,0,1,0,0-2H15a1,1,0,0,0-1,1m7.46-4.95L18.64,9.22a1,1,0,0,0-1.41,1.41L20,13.47a1,1,0,1,0,1.41-1.41m8.48,1.41,2.83-2.83a1,1,0,0,0-1.41-1.41l-2.83,2.83a1,1,0,1,0,1.41,1.41M26,11V7a1,1,0,0,0-2,0v4a1,1,0,1,0,2,0M55,0H5A5.18,5.18,0,0,0,0,5V31a1,1,0,0,0,2,0V5.07A3.17,3.17,0,0,1,5,2H55a3,3,0,0,1,3,3V41a2.93,2.93,0,0,1-3,3H5a2.93,2.93,0,0,1-3-3V36H55a1,1,0,0,0,1-1.28A44.9,44.9,0,0,0,50.17,22.3a3.07,3.07,0,0,0-4.06-1.09,2.89,2.89,0,0,0-.81.71,3.64,3.64,0,0,0-5.95.88,3.64,3.64,0,0,0-5.16,1.37l-6-8.32c-1.89-2.58-3.83-1.86-4.58-1.42a3.2,3.2,0,0,0-1.59,2.21,3.89,3.89,0,0,0,.52,2.63l7.57,12.25a1,1,0,1,0,1.7-1.05L24.29,18.25A1.87,1.87,0,0,1,24,17a1.19,1.19,0,0,1,.62-0.84c0.28-.16.93-0.54,2,0.87l7.72,10.74A1,1,0,0,0,36,26.69a1.63,1.63,0,1,1,2.82-1.63l0.66,1.14h0a1,1,0,0,0,1.73-1h0A1.63,1.63,0,0,1,44,23.56l1,1.71h0a1,1,0,1,0,1.73-1h0a1,1,0,0,1-.08-0.73,1,1,0,0,1,.43-0.59,1,1,0,0,1,.73-0.06,1,1,0,0,1,.65.5A44.06,44.06,0,0,1,53.65,34H1a1,1,0,0,0-1,1v6a5,5,0,0,0,5,5H55a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5M30,38a2,2,0,1,1-2,2,2,2,0,0,1,2-2"
              ></path>
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('partners-authors')].body"></p>
          </router-link>
        </li>
        <li @click="trackPageClick('partners_authors')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'announcements'}">
            <h3 class="title">{{categories[getCategoryIdByName('announcements')].title}}</h3>
            <svg
              class="icon"
              width="50px"
              height="50px"
              viewBox="0 0 60 60"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Partners & Authors</title>
              <path
                d="M56,9V51a4.9,4.9,0,0,1-.69,2.48,1,1,0,0,1-1.72-1A2.91,2.91,0,0,0,54,51V9a7,7,0,0,0-7-7H9A7,7,0,0,0,5.5,15a1,1,0,1,1-1,1.73A9,9,0,0,1,0,9H0A9,9,0,0,1,9,0H47a9,9,0,0,1,9,9h0ZM17,16h4a1,1,0,0,0,0-2H17a1,1,0,0,0,0,2h0Zm22,0a1,1,0,0,0,0-2H37a1,1,0,0,0,0,2h2Zm-6-2H25a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2h0ZM17,28h6a1,1,0,0,0,0-2H17a1,1,0,0,0,0,2h0Zm23-1a1,1,0,0,0,1,1h6a1,1,0,0,0,0-2H41a1,1,0,0,0-1,1h0Zm-6-6a1,1,0,0,0,1,1H45a1,1,0,0,0,0-2H35a1,1,0,0,0-1,1h0Zm-7,5a1,1,0,0,0,0,2H37a1,1,0,0,0,0-2H27ZM17,22H31a1,1,0,0,0,0-2H17a1,1,0,0,0,0,2h0Zm0,12H29a1,1,0,0,0,0-2H17a1,1,0,0,0,0,2h0Zm27-1a1,1,0,0,0-1-1H33a1,1,0,0,0,0,2H43a1,1,0,0,0,1-1h0Zm0,19a6,6,0,1,1,6-6,6,6,0,0,1-6,6h0Zm4-6a4,4,0,1,0-4,4,4,4,0,0,0,4-4h0Zm2.63,5.35a1,1,0,0,0-1.73,1l2.16,3.74-0.62,0a1,1,0,0,0-.77.45l-0.34.52-2.14-3.71a1,1,0,0,0-1.73,1l3,5.11a1,1,0,0,0,.84.5h0a1,1,0,0,0,.83-0.45l1-1.45,1.73-.1a1,1,0,0,0,.81-1.5l-3-5.14h0ZM42.19,53a1,1,0,0,0-1.37.37l-2.15,3.73-0.34-.52a1,1,0,0,0-.77-0.45l-0.62,0,2.19-3.79a1,1,0,0,0-1.73-1l-3,5.19a1,1,0,0,0,.81,1.5l1.73,0.1,1,1.45a1,1,0,0,0,.83.45h0a1,1,0,0,0,.84-0.5l3-5.13A1,1,0,0,0,42.19,53h0ZM17.11,46.42a1,1,0,1,0,1.79-.89c-1-2-1.21-3.76-.6-4.75A1.85,1.85,0,0,1,20,40a0.81,0.81,0,0,1,.77.32c0.74,1.07,0,4.35-.7,6.33a1,1,0,0,0,1.64,1.06c0.43-.43.89-0.85,1.29-1.2V47a1,1,0,0,0,1.71.71,12.51,12.51,0,0,1,1.43-1.22l0,0.07A1,1,0,0,0,27,48h4a1,1,0,1,0,0-2H28.4a1.93,1.93,0,0,0-.18-1.35A1.39,1.39,0,0,0,27,44a3.89,3.89,0,0,0-2,.84,1.16,1.16,0,0,0-.7-1,1.37,1.37,0,0,0-1.45.25c0.33-1.72.42-3.71-.43-4.95A2.78,2.78,0,0,0,20,38a3.82,3.82,0,0,0-3.4,1.75c-1,1.61-.81,4.05.51,6.7h0ZM32,54H13a3,3,0,0,1-3-3V5A1,1,0,0,0,9,4,5,5,0,0,0,4,9,1,1,0,0,0,6,9,3,3,0,0,1,8,6.15V51a5,5,0,0,0,5,5H32a1,1,0,0,0,0-2h0Z"
              ></path>
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('announcements')].body"></p>
          </router-link>
        </li>
      </ul>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import { getComponent, getCategoryPageName, getCategoryIdByName, trackPageView, trackPageClick } from '@/utils/common';
export default {
  name: 'home',
  metaInfo() {
    return {
      titleTemplate: `%s | ${this.$t('headerTitle')}`
    };
  },
  created() {
    if (this.$route.query.request) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    trackPageView('home');
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    },
    articles() {
      return this.$store.state.articles;
    },
    // Getting Component Dynamically & Asynchronously
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    }
  },
  methods: {
    getCategoryPageName(catId) {
      return getCategoryPageName(catId, this.$store.getters.flowObject.pages);
    },
    getCategoryIdByName(catName) {
      return getCategoryIdByName(catName);
    },
    hideSuccessMessage() {
      this.$router.push({ path: window.location.pathname });
    },
    trackPageClick(clickName) {
      return trackPageClick(clickName);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/variables.scss';
.category-boxes {
  list-style-type: none;
  padding: 0;
  font-size: 0.9rem;
  font-weight: 300;
  padding: 0 5%;
  @media (min-width: 600px) {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    color: #2b2b2b;
  }
  @media (min-width: 960px) {
    font-size: 1rem;
  }
  @media (min-width: 1160px) {
    padding: 0;
    width: 90%;
  }
}
.category-boxes__item {
  margin-bottom: 2rem;
  padding: 0 1rem;
}
.category-boxes__item__link {
  text-align: center;
  border: 1px solid #888;
  text-decoration: none;
  margin: 0 auto;
  line-height: 1.5rem;
  border-radius: 3px;
  padding: 1rem;
  display: block;
  height: 100%;
  max-width: 28.3rem;
  .title {
    color: #2b2b2b;
    font-weight: 700 !important;
    transition: 0.2s linear all;
    line-height: 27px;
    margin: 0 0 0.3rem 0;
  }
  .icon {
    width: 27px;
    polygon,
    path {
      transition: 0.2s linear all;
      fill: $theme-highlight;
    }
  }
  .text {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: #2b2b2b;
  }
  &:hover {
    background-color: $theme-highlight;
    color: #fff;
    .title,
    .text {
      color: #fff;
    }
    .icon {
      polygon,
      path {
        fill: #fff;
      }
    }
  }
}
@media (min-width: 641px) {
  .category-boxes__item__link {
    padding: 1.5em;
    .title {
      margin-top: 0.6rem;
      margin-bottom: 1rem;
      font-size: 1.1rem;
    }
    .icon {
      width: 40px;
    }
    .text {
      margin-top: 1.1rem;
      font-size: 1rem;
    }
  }
}
.category-boxes__item {
  width: 100%;
}
@media (min-width: 40em) {
  .category-boxes__item {
    width: calc(50% - 2px);
  }
}
@media (min-width: 52em) {
  .category-boxes__item {
    width: calc(33.3% - 2px);
    margin-bottom: 2em;
  }
}
@media (min-width: 73em) {
  .category-boxes__item {
    width: calc(20% - 2px);
  }
}

@media (min-width: 1024px) {
  // .category-boxes {
  //   justify-content: center;
  // }
}
.notification-inner {
  position: relative;
  margin: 0 auto;
  padding: 0 20px;
  max-width: 980px;
}
.notification {
  border: 1px solid;
  display: table;
  font-family: sans-serif;
  font-size: 12px;
  padding: 10px 15px 15px 15px !important;
  margin: 0px 0px 160px 0px !important;
  transition: height 0.2s;
  width: 100%;
  color: #555;
  text-align: center;
}
.notification-notice {
  background: #dbf3ff;
}
.notification-text {
  padding-left: 15px;
  padding-right: 5px;
  width: 100%;
  display: block;
  text-align: left;
}
.notification-dismiss,
.notification-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-decoration: none;
}
.notification-dismiss {
  cursor: pointer;
  right: 0;
}
.notification-icon {
  left: 0;
}
.notification-dismiss::before {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
}
.notification-dismiss::before {
  color: #000;
  color: initial;
  content: '\2715';
  font-family: sans-serif;
  font-size: 16px;
  opacity: 0.6;
  transition: opacity 100ms ease;
  text-decoration: none !important;
}
.notification-icon::before {
  content: '\2713';
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
  border: 1px solid #b5e0f5;
  border-radius: 50%;
  font-family: 'entypo';
}
</style>
